import { render, staticRenderFns } from "./PaymentReports.vue?vue&type=template&id=33b5bb10&scoped=true"
import script from "./PaymentReports.vue?vue&type=script&lang=js"
export * from "./PaymentReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5bb10",
  null
  
)

export default component.exports